import { IGNORE_FILE_REGEX } from '../constants';

/**
 * Whether a file should be left out of an upload, going by its name or the
 * name of any directory above it, the same way walking a directory skips it.
 */
export const isIgnoredFilePath = (filePath: string): boolean =>
  filePath.split('/').some((segment) => IGNORE_FILE_REGEX.test(segment));
